import addMount from "../../core/addMount";
import FeeList from "./FeeList.entry";

addMount({ appName: "fee-list", app: FeeList });
